module.exports = __webpack_public_path__ + "static/media/deshRide.84c77e1e.png";